export class PreTaxNetIncomeConversionFactor {
  /**
   *
   * @param {Number} preTaxFreeCashFlow
   * @param {Number} ebit
   * @param {Number} predictedFactor
   */
  constructor({
    preTaxFreeCashFlow = 0,
    ebit = 0,
  }) {
    this.preTaxFreeCashFlow = preTaxFreeCashFlow
    this.ebit = ebit
  }

  get predictedFactor() {
    if (this.ebit === 0) return 0

    return (this.preTaxFreeCashFlow / this.ebit) * 100
  }
}

export class CashToEarningsFactor {
  /**
   *
   * @param {Number} preTaxNetCashFlowCapitalizationRate
   * @param {Number} predictedFactor
   * @param {Number} preTaxNetIncomeCapitalizationRate
   * @param {Number} cashToEarningsFactor
   * @param {Number} preTaxIncomeMultiple
   */
  constructor({
    preTaxNetCashFlowCapitalizationRate = 0,
    predictedFactor = 0,
  }) {
    this.preTaxNetCashFlowCapitalizationRate = preTaxNetCashFlowCapitalizationRate
    this.predictedFactor = predictedFactor
  }

  get preTaxNetIncomeCapitalizationRate() {
    if (this.predictedFactor === 0) return 0

    return (this.preTaxNetCashFlowCapitalizationRate / this.predictedFactor) * 100
  }

  get cashToEarningsFactor() {
    return this.preTaxNetIncomeCapitalizationRate - this.preTaxNetCashFlowCapitalizationRate
  }

  get preTaxIncomeMultiple() {
    if (this.preTaxNetIncomeCapitalizationRate === 0) return 0

    return (1 / this.preTaxNetIncomeCapitalizationRate) * 100
  }
}


export default class ForecastCashToEarnings {
  /**
   *
   * @param {PreTaxNetIncomeConversionFactor} preTaxNetIncomeConversionFactor
   * @param {CashToEarningsFactor} cashToEarningsFactor
   */
  constructor({
    preTaxNetIncomeConversionFactor,
    cashToEarningsFactor
  }) {
    this.preTaxNetIncomeConversionFactor = preTaxNetIncomeConversionFactor
    this.cashToEarningsFactor = cashToEarningsFactor
  }
}